/**
 * NotFound — `*`
 *
 * Placeholder. Wave 2 suggests Rehearsal / Notes per console-architecture §3.
 */

export default function NotFound() {
  return (
    <section data-testid="page-not-found">
      <h1>Off stage</h1>
      <p className="text-paper-cream-dim">
        That page is not on the score. Try Rehearsal or Notes.
      </p>
    </section>
  );
}
